import { makeStyles } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";

// new header color
const myTheme = createTheme({
  palette: {
    neutral: {
      banner: "#c3c3e3", // light gray - blueish
      primary: "#1976d2", // blue
      secondary: "#e33371", // pink
      text: "#000857", // black
    },
  },
});

export default makeStyles((theme) => ({
  logotype: {
    color: "white",
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
    fontWeight: 500,
    fontSize: 18,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  logotypeImage: {
    width: 120,
    height: 35,
    marginTop: "-0.2%",
  },
  logotypeImageSM: {
    width: 70,
    height: 35,
    marginTop: "-0.2%",
  },
  appBar: {
    width: "100vw",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  autoComplete: {
    borderRadius: "50px 50px 0 0 ",
    border: "solid 1px",
    borderColor: "white",
    width: 300,
  },
  toolbar: {
    backgroundColor: myTheme.palette.neutral.banner,
    color: myTheme.palette.neutral.text,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  programButtonSpacingPrimary: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    backgroundColor: myTheme.palette.neutral.primary,
    "&:disabled": {
      background: "rgba(0, 0, 0, 0.12)",
      backgroundColor: myTheme.palette.neutral.primary,
      color: "white",
      borderColor: "white",
      borderWidth: 4,
      border: "solid 1px",
    },
  },
  programButtonSpacingDisabledPrimary: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    backgroundColor: myTheme.palette.neutral.primary,
    "&:disabled": {
      background: "rgba(0, 0, 0, 0.12)",
      backgroundColor: myTheme.palette.neutral.primary,
      color: "white",
    },
  },
  programButtonSpacingDisabledActivePrimary: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    backgroundColor: myTheme.palette.neutral.primary,
    "&:disabled": {
      borderColor: "white",
      borderWidth: 4,
      border: "solid 1px",
      background: "rgba(0, 0, 0, 0.12)",
      backgroundColor: myTheme.palette.neutral.primary,
      color: "white",
    },
  },
  programButtonSpacingSecondary: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    backgroundColor: myTheme.palette.neutral.secondary,
    "&:disabled": {
      background: "rgba(0, 0, 0, 0.12)",
      backgroundColor: myTheme.palette.neutral.secondary,
      color: "white",
      borderColor: "white",
      borderWidth: 4,
      border: "solid 1px",
    },
  },
  programButtonSpacingDisabledSecondary: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    backgroundColor: myTheme.palette.neutral.secondary,
    "&:disabled": {
      background: "rgba(0, 0, 0, 0.12)",
      backgroundColor: myTheme.palette.neutral.secondary,
      color: "white",
    },
  },
  programButtonSpacingDisabledActiveSecondary: {
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
    backgroundColor: myTheme.palette.neutral.secondary,
    "&:disabled": {
      borderColor: "white",
      borderWidth: 4,
      border: "solid 1px",
      background: "rgba(0, 0, 0, 0.12)",
      backgroundColor: myTheme.palette.neutral.secondary,
      color: "white",
    },
  },
  hide: {
    display: "none",
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: "relative",
    borderRadius: 25,
    paddingLeft: theme.spacing(2.5),
    width: 36,
    backgroundColor: fade(theme.palette.common.black, 0),
    transition: theme.transitions.create(["background-color", "width"]),
    "&:hover": {
      cursor: "pointer",
      backgroundColor: fade(theme.palette.common.black, 0.08),
    },
  },
  searchFocused: {
    backgroundColor: fade(theme.palette.common.black, 0.08),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 250,
    },
  },
  searchIcon: {
    width: 36,
    right: 0,
    height: "100%",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: theme.transitions.create("right"),
    "&:hover": {
      cursor: "pointer",
    },
  },
  searchIconOpened: {
    right: theme.spacing(1.25),
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    height: 36,
    padding: 0,
    paddingRight: 36 + theme.spacing(1.25),
    width: "100%",
  },
  input: {
    backgroundColor: "white",
    borderRadius: 4,
    border: "solid 1px",
    borderColor: "white",
    width: 300,
  },
  messageContent: {
    display: "flex",
    flexDirection: "column",
  },
  headerMenu: {
    marginTop: theme.spacing(7),
  },
  headerMenuList: {
    display: "flex",
    flexDirection: "column",
  },
  headerMenuItem: {
    "&:hover, &:focus": {
      backgroundColor: myTheme.palette.neutral.main,
      // color: "white",
    },
  },
  headerMenuButton: {
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5),
  },
  headerMenuButtonSandwich: {
    marginLeft: 9,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
    padding: theme.spacing(0.5),
  },
  headerMenuButtonCollapse: {
    marginRight: theme.spacing(2),
  },
  headerIcon: {
    fontSize: 28,
    color: "rgba(255, 255, 255, 0.35)",
  },
  headerIconCollapse: {
    color: "white",
  },
  profileMenu: {
    minWidth: 265,
  },
  profileMenuUser: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
  },
  profileMenuItem: {
    color: theme.palette.text.hint,
  },
  profileMenuIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.text.hint,
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
  profileMenuLink: {
    fontSize: 16,
    textDecoration: "none",
    "&:hover": {
      cursor: "pointer",
    },
  },
   messageNotification: {
    height: "auto",
    display: "flex",
    alignItems: "center",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
    },
  },
  messageNotificationSide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: theme.spacing(2),
  },
  messageNotificationBodySide: {
    alignItems: "flex-start",
    marginRight: 0,
  },
  sendMessageButton: {
    margin: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  sendButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  purchaseBtn: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    marginRight: theme.spacing(3),
  },
  popupButtonSpacing: {
    margin: theme.spacing(1),
  },
  popupDivCenter: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));
